/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterTaxRatesDto
 */
export interface FilterTaxRatesDto {
    /**
     * Market identifier
     * @type {string}
     * @memberof FilterTaxRatesDto
     */
    market?: string;
}

/**
 * Check if a given object implements the FilterTaxRatesDto interface.
 */
export function instanceOfFilterTaxRatesDto(value: object): value is FilterTaxRatesDto {
    return true;
}

export function FilterTaxRatesDtoFromJSON(json: any): FilterTaxRatesDto {
    return FilterTaxRatesDtoFromJSONTyped(json, false);
}

export function FilterTaxRatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterTaxRatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'market': json['market'] == null ? undefined : json['market'],
    };
}

export function FilterTaxRatesDtoToJSON(json: any): FilterTaxRatesDto {
    return FilterTaxRatesDtoToJSONTyped(json, false);
}

export function FilterTaxRatesDtoToJSONTyped(value?: FilterTaxRatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'market': value['market'],
    };
}

